<template>
  <div
    v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
    class="app-breadcrumb-container"
  >
    <!-- Modern Breadcrumb Navigation -->
    <nav class="breadcrumb-nav d-print-none">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link
            to="/"
            class="breadcrumb-link"
          >
            <svg
              viewBox="0 0 20 20"
              fill="currentColor"
              class="breadcrumb-icon"
            >
              <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
            </svg>
            Tableau de bord
          </router-link>
        </li>

        <!-- Breadcrumb items from route meta -->
        <template v-for="(item, index) in $route.meta.breadcrumb">
          <li
            :key="`separator-${index}`"
            class="breadcrumb-separator"
          >
            <svg
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                clip-rule="evenodd"
              />
            </svg>
          </li>
          <li
            :key="`item-${index}`"
            class="breadcrumb-item"
            :class="{ active: item.active }"
          >
            <router-link
              v-if="item.to && !item.active"
              :to="item.to"
              class="breadcrumb-link"
            >
              {{ item.text }}
            </router-link>
            <span
              v-else
              class="breadcrumb-current"
            >
              {{ item.text }}
            </span>
          </li>
        </template>
      </ol>
    </nav>

    <!-- Page Title Header -->
    <div
      v-if="$route.meta.pageTitle"
      class="page-header d-print-none"
    >
      <h2 class="page-title">
        {{ $route.meta.pageTitle }}
      </h2>
    </div>
  </div>
</template>

<script>
import Ripple from 'vue-ripple-directive'

export default {
  directives: {
    Ripple,
  },
}
</script>

<style scoped>
/* Modern Breadcrumb Styles */
.app-breadcrumb-container {
  margin-bottom: 1.5rem;
}

.breadcrumb-nav {
  margin-bottom: 1rem;
}

.breadcrumb {
  display: flex;
  align-items: center;
  list-style: none;
  margin: 0;
  padding: 0.75rem 1rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e5e7eb;
  flex-wrap: wrap;
}

.breadcrumb-item {
  display: flex;
  align-items: center;
}

.breadcrumb-link {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #6b7280;
  text-decoration: none;
  font-weight: 500;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  transition: all 0.2s ease;
  font-size: 0.875rem;
}

.breadcrumb-link:hover {
  color: #E80000;
  background: #fef2f2;
  text-decoration: none;
}

.breadcrumb-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.breadcrumb-separator {
  margin: 0 0.5rem;
  color: #d1d5db;
  display: flex;
  align-items: center;
}

.breadcrumb-separator svg {
  width: 14px;
  height: 14px;
}

.breadcrumb-current {
  color: #1f2937;
  font-weight: 600;
  font-size: 0.875rem;
}

.breadcrumb-item.active .breadcrumb-current {
  color: #1f2937;
}

/* Page Header */
.page-header {
  margin-bottom: 1rem;
}

.page-title {
  color: #1f2937;
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
  line-height: 1.2;
}

/* Dark theme support */
.dark-layout {
  .breadcrumb {
    background: #283046;
    border-color: #3b4253;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  }

  .breadcrumb-link {
    color: #b4b7bd;
  }

  .breadcrumb-link:hover {
    color: #E80000;
    background: rgba(232, 0, 0, 0.1);
  }

  .breadcrumb-separator {
    color: #6e6b7b;
  }

  .breadcrumb-current {
    color: #d0d2d6;
  }

  .page-title {
    color: #d0d2d6;
  }
}

/* Responsive design */
@media (max-width: 768px) {
  .breadcrumb {
    padding: 0.5rem 0.75rem;
    font-size: 0.8rem;
  }

  .breadcrumb-link {
    gap: 0.25rem;
    padding: 0.125rem 0.25rem;
    font-size: 0.8rem;
  }

  .breadcrumb-icon {
    width: 14px;
    height: 14px;
  }

  .breadcrumb-separator {
    margin: 0 0.25rem;
  }

  .breadcrumb-separator svg {
    width: 12px;
    height: 12px;
  }

  .page-title {
    font-size: 1.25rem;
  }
}

@media (max-width: 480px) {
  .breadcrumb {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }

  .breadcrumb-separator {
    display: none;
  }

  .breadcrumb-item {
    width: 100%;
  }

  .breadcrumb-link,
  .breadcrumb-current {
    width: 100%;
  }
}

/* Print styles */
@media print {
  .breadcrumb-nav {
    display: none !important;
  }
}
</style>
